export function triggerEvent(node, eventTag, data) {
	const eventData = {
		bubbles:true,
		cancelable:true
	};
	if(typeof data !== 'undefined')
	{
		eventData.detail = data;
	}

	ensureCustomEvent();

	const event = new CustomEvent(eventTag,eventData);

	node.dispatchEvent(event);

	dataholder.manualEventsFired.push({
		node: node,
		tag: eventTag,
		data: data
	});
}

function ensureCustomEvent()
{
	if ( typeof window.CustomEvent === "function" ) return false;

	function CustomEvent ( event, params ) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;

	window.CustomEvent = CustomEvent;
}

export function triggerDocumentEvent(eventTag, data){
	triggerEvent(document,eventTag,data)
}

export function hasEventOccured(eventTag)
{
	for(let i = 0; i < dataholder.manualEventsFired.length; i++)
	{
		if(dataholder.manualEventsFired[i].tag === eventTag)
			return true;
	}
	return false;
}

export function triggerCallbackAfterEventOrIfFired(triggerEvent, callback, onlyOnce)
{
	let hasTriggered = false;
	onlyOnce = typeof onlyOnce !== 'boolean' ? true : onlyOnce;

	if( hasEventOccured(triggerEvent) )
	{
		hasTriggered = true;
		callback();
	}

	$(document).on(triggerEvent,function(e){
		if(onlyOnce === false || !hasTriggered)
		{
			hasTriggered = true;
			callback();
		}
	});
}
